import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";

const ErrorAlertBox = ({ message, onClose }) => {
  return (
    <div style={styles.overlay}>
      <div
        style={styles.alertBox}
        className="d-flex align-items-center justify-content-center">
        <ErrorOutlineIcon sx={{ color: "#d32f2f" }} />
        <div className="ms-3">{message}</div>
        <div className="m-0 p-0 ms-auto">
          <CloseIcon
            sx={{ color: "#5F2120", cursor: "pointer" }}
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1500",
  },
  alertBox: {
    backgroundColor: "#FDEDED",
    padding: "10px",
    borderRadius: "5px",
    textAlign: "center",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    zIndex: "1502",
    minWidth: "400px",
    color: "#5F2120",
  },
};

export default ErrorAlertBox;
